export const extractDate = (date?: string): string => {
  if (!date) return '';
  const d = date.split('/');
  if (d.length < 3) return date;
  return `${d[2]}-${parseInt(d[1])}-${d[0]}`;
};
